// extracted by mini-css-extract-plugin
export default {"container":"AddReport_container__2PuaR","form":"AddReport_form__c6pRm"};